/**
 * AI Data Service - Frontend service for AI data extraction
 * Handles communication with the AI Data API
 */
import api from './api';

/**
 * Process call notes to extract structured lead information
 * @param {string} notes - Call notes text to process
 * @param {string} leadId - ID of the lead
 * @returns {Promise<Object>} - Extracted structured lead data
 */
export const processCallNotes = async (notes, leadId) => {
  try {
    const response = await api.post('/api/ai-data/process-call-notes', {
      notes,
      leadId
    });
    
    if (response.data.success && response.data.data) {
      return response.data.data;
    } else {
      throw new Error(response.data.error || 'Failed to extract data from call notes');
    }
  } catch (error) {
    console.error('[AI-DATA] Error processing call notes:', error);
    throw error;
  }
};

/**
 * Process any text to extract structured lead information
 * @param {string} text - Text to process
 * @returns {Promise<Object>} - Extracted structured lead data
 */
export const processText = async (text) => {
  try {
    const response = await api.post('/api/ai-data/process', { text });
    
    if (response.data.success && response.data.data) {
      return response.data.data;
    } else {
      throw new Error(response.data.error || 'Failed to extract data from text');
    }
  } catch (error) {
    console.error('[AI-DATA] Error processing text:', error);
    throw error;
  }
};

/**
 * Check if AI data extraction is properly configured
 * @returns {Promise<Object>} - AI service status
 */
export const checkAiStatus = async () => {
  try {
    const response = await api.get('/api/ai-data/status');
    return response.data.status || { configured: false };
  } catch (error) {
    console.error('[AI-DATA] Error checking AI status:', error);
    return { configured: false, error: error.message };
  }
};

export default {
  processCallNotes,
  processText,
  checkAiStatus
};
